/* Testimonials Mixed — autorotate for the section's slider-component */
(function () {
  const MOBILE_MQ = window.matchMedia('(max-width: 991px)');

  function initAutorotate(root) {
    if (root.dataset.autorotateInit === 'true') return;
    const sliderComponent = root.querySelector('slider-component');
    if (!sliderComponent) return;
    const slider = sliderComponent.querySelector('[id^="Slider-"]');
    const nextButton = sliderComponent.querySelector('button[name="next"]');
    if (!slider || !nextButton) return;

    root.dataset.autorotateInit = 'true';

    const desktopOn = root.dataset.autorotateDesktop === 'true';
    const mobileOn = root.dataset.autorotateMobile === 'true';
    const speed = (parseFloat(root.dataset.autorotateSpeed) || 5) * 1000;

    let timer = null;
    let hovered = false;
    let inView = true;

    // Note: deliberately does NOT honour prefers-reduced-motion — Windows "Animation effects: off"
    // and iOS "Reduce Motion" both set it, which silently disabled the rotation for the merchant.
    const isEnabled = () => (MOBILE_MQ.matches ? mobileOn : desktopOn);
    const videoOpen = () => !!root.querySelector('deferred-media[loaded]');

    function advance() {
      if (hovered || !inView || !isEnabled() || videoOpen()) return;
      if (document.hidden) return;
      if (nextButton.hasAttribute('disabled')) {
        slider.scrollTo({ left: 0 });
      } else {
        nextButton.click();
      }
    }

    function start() {
      stop();
      if (!isEnabled()) return;
      timer = setInterval(advance, speed);
    }

    function stop() {
      if (timer) clearInterval(timer);
      timer = null;
    }

    root.addEventListener('mouseenter', () => { hovered = true; });
    root.addEventListener('mouseleave', () => { hovered = false; });
    root.addEventListener('focusin', () => { hovered = true; });
    root.addEventListener('focusout', () => { hovered = false; });
    // Restart the timer after a manual swipe/click so the next auto-advance isn't rushed.
    slider.addEventListener('scroll', () => { if (timer) start(); }, { passive: true });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver((entries) => {
        inView = entries[0].isIntersecting;
      }, { threshold: 0.25 }).observe(root);
    }

    MOBILE_MQ.addEventListener('change', start);
    start();

    root.tmAutorotateStop = stop;
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.testimonial-mixed[data-autorotate="true"]').forEach(initAutorotate);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  // Theme editor support
  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
  document.addEventListener('shopify:section:unload', (e) => {
    e.target.querySelectorAll('.testimonial-mixed').forEach((r) => r.tmAutorotateStop && r.tmAutorotateStop());
  });
})();
